import Prompt from './prompt'
export type { PromptProps } from './prompt'
export default Prompt
